var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("v-tour", {
        attrs: {
          name: "task-detail",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.onTabClick },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Overview"), name: "overview" } },
            [
              _c("task-overview", {
                on: {
                  "click-log": function($event) {
                    _vm.activeTabName = "log"
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Log"), name: "log" } },
            [
              _c("log-view", {
                on: {
                  search: function($event) {
                    return _vm.getTaskLog(true)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Results"), name: "results" } },
            [
              _c(
                "div",
                { staticClass: "button-group" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-download",
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-download"
                      },
                      on: { click: _vm.downloadCSV }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Download CSV")) + " ")]
                  )
                ],
                1
              ),
              _c("general-table-view", {
                attrs: {
                  data: _vm.taskResultsData,
                  columns: _vm.taskResultsColumns,
                  "page-num": _vm.resultsPageNum,
                  "page-size": _vm.resultsPageSize,
                  total: _vm.taskResultsTotalCount
                },
                on: { "page-change": _vm.onResultsPageChange }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }